export default __webpack_public_path__ + "static/media/shape2.4bfee167.svg";